<button
    [disabled]="btnTool.disabled"
    [pTooltip]="btnTool.pTooltip"
    [class]="btnTool.class"
    pButton
    type="button"
    [icon]="btnTool.icon"
    (click)="onClickButton()"
></button>
